var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-container"},[_c('div',{staticClass:"editor-container"},[_c('dnd-list',{attrs:{"list1":_vm.list1,"list2":_vm.list2,"list1-title":"List","list2-title":"Article pool"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }